/* Dawbu mobile menu drawer: swipe left to close. */
(() => {
  const drawer = document.querySelector('header-drawer');
  const details = drawer && drawer.querySelector('#Details-menu-drawer-container');
  const summary = details && details.querySelector(':scope > summary');
  const panel = details && details.querySelector('#menu-drawer');
  if (!panel || !summary) return;

  // Start fetching the drawer's (lazy) images as soon as the menu button is
  // touched, so the circles are ready by the time the drawer slides in.
  const warmImages = () => {
    panel.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
  };
  summary.addEventListener('touchstart', warmImages, { once: true, passive: true });
  summary.addEventListener('mouseenter', warmImages, { once: true });

  const CLOSE_MS = 200;
  let startX = 0;
  let startY = 0;
  let dx = 0;
  let tracking = false;
  let horizontal = false;

  const clearInline = () => {
    panel.style.transition = '';
    panel.style.transform = '';
  };

  panel.addEventListener(
    'touchstart',
    (e) => {
      if (!details.classList.contains('menu-opening') || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      tracking = true;
      horizontal = false;
    },
    { passive: true }
  );

  panel.addEventListener(
    'touchmove',
    (e) => {
      if (!tracking) return;
      const x = e.touches[0].clientX - startX;
      const y = e.touches[0].clientY - startY;
      if (!horizontal) {
        if (Math.abs(x) < 10 && Math.abs(y) < 10) return;
        // Vertical scroll or a rightward swipe: leave it to the browser
        if (Math.abs(y) > Math.abs(x) || x > 0) {
          tracking = false;
          return;
        }
        horizontal = true;
      }
      dx = Math.min(0, x);
      panel.style.transition = 'none';
      panel.style.transform = `translateX(${dx}px)`;
    },
    { passive: true }
  );

  const onEnd = () => {
    if (!tracking) return;
    tracking = false;
    if (!horizontal) return;

    panel.style.transition = `transform ${CLOSE_MS}ms ease`;
    if (-dx > Math.min(80, panel.offsetWidth * 0.25)) {
      panel.style.transform = 'translateX(-100%)';
      setTimeout(() => {
        drawer.closeMenuDrawer(new Event('swipe'), summary);
        summary.setAttribute('aria-expanded', 'false');
        // Keep it off-screen until the theme's close animation has finished
        setTimeout(clearInline, 450);
      }, CLOSE_MS);
    } else {
      panel.style.transform = '';
      setTimeout(clearInline, CLOSE_MS);
    }
  };

  panel.addEventListener('touchend', onEnd);
  panel.addEventListener('touchcancel', onEnd);
})();
